export const initialPaycorSettingsData = {
  export_paygrids: [] as Array<any>,
  // use_labor_codes: [],
};
